import React, { useEffect, useState } from "react";
import MarkesEvaluationTable from "../../Components/MarkesEvaluationTable";
import YesNoTable from "../../Components/yesNoTable";
import RecommendationsSection from "../../Components/RecommendationsSection";
import SharedDiv from "../../Components/SharedDiv/SharedDiv";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAllMarksBySubTaskGuid,
  GetAVGForSubTasksByTaskGuid,
} from "../../Redux/Reducers/MarksManager";
import { GetAllYesNoListByTaskGuid } from "../../Redux/Reducers/YesNoManager";
import { useParams } from "react-router-dom";
import { GetComponentByFlow } from "../../Redux/Reducers/ComponentByFlow";
import { GetActionButtons } from "../../Redux/Reducers/ActionButtons";
import ButtonActionManager from "../ButtonActionManager";
import { GetAllSubTaskByMain } from "../../Redux/Reducers/AllSubTaskByMain";
import SubTaskSection from "./SubTaskSection";
import RecommendationMainTask from "../RecommendationMainTask";
import { useCookies } from "react-cookie";
import { jwtDecode } from "jwt-decode";
import LoaderAHSF from "../../Components/LoaderAHSF";

export default function AllMainComponentsPage() {
  const dispatch = useDispatch();
  let { flow } = useParams();
  let { taskId } = useParams();
  let { taskStatusGUID } = useParams();
  let { userGuid } = useParams();
  const [cookies, setCookie] = useCookies([]);
  const [loading, setLoading] = useState(true);

  //   let { mainTaskId } = useParams();
  //[,]
  // فك تشفير ال  param
  const decodeParam = (param) => atob(param);
  //console.log(
  //     decodeParam(flow),
  //     "param",
  //     decodeParam(taskId)
  //     // decodeParam(mainTaskId)
  //   );
  const state = useSelector((state) => {
    return {
      MarksManager: state.MarksManager.MarksManager,
      loadingMarksManager: state.MarksManager.loadingMarksManager,
      YesNoManagerBySubTask: state.YesNoManagerBySubTask?.YesNoManagerBySubTask,
      loadingYesNoManagerBySubTask: state.loadingYesNoManagerBySubTask,
      OneComponentByFlow: state.OneComponentByFlow,
      ActionButtons: state.ActionButtons.ActionButtons,
      loadingActionButtons: state.ActionButtons.loadingActionButtons,
      AllSubTaskByMain: state.AllSubTaskByMain.AllSubTaskByMain,
      UserInfo: state.UserInfo.UserInfo,
      MarksAvg: state.MarksManager.MarksAvg,
    };
  });
  let userInfoData = jwtDecode(cookies.loginTokenSSO);

  //[,]
  //to get all components by flow
  useEffect(() => {
    getAllData();
  }, []);
  const getAllData = async () => {
    const GetComponent = await dispatch(
      GetComponentByFlow({
        appiliacationInfo: localStorage.getItem(
          "aI_ApplicationInformationId_Manager"
        ),
        flowGUID: decodeParam(flow),
      })
    );
    //---------------------------------------------------------------

    //[,]
    //to get all  action  buttons
    const GetAction = await dispatch(
      GetActionButtons({
        aI_ApplicationInformationId: localStorage.getItem(
          "aI_ApplicationInformationId_Manager"
        ),
        flowGUID: decodeParam(flow),
        isMainFlow: true,
      })
    );
    //---------------------------------------------------------------

    //[,]
    //to get subtask info  by taskId
    const GetSubTask = await dispatch(GetAllSubTaskByMain(decodeParam(taskId)));
    //to get subtask AVG  by taskId

    const AVGForSubTasks = await dispatch(
      GetAVGForSubTasksByTaskGuid(decodeParam(taskId))
    );

    if (GetAction.payload && GetSubTask.payload && GetComponent.payload) {
      setLoading(false);
    }
  };
  //console.log(state.AllSubTaskByMain, "state.AllSubTaskByMain");

  return (
    <>
      <div>
        {/* [,] */}
        {/* to render all subtasks on this main task*/}
        {state.AllSubTaskByMain && state.AllSubTaskByMain.length > 0
          ? state.AllSubTaskByMain.map((component) => {
              return (
                <SharedDiv
                  showTitle={true}
                  titleName={
                    component.uS_User
                      ? component.uS_User?.firstName +
                        " " +
                        component.uS_User?.lastName
                      : "غير محدد"
                  }
                  id_Title="midTi"
                  child={[
                    <SubTaskSection
                      flowGUID={component.taskFlow.flowGUID}
                      taskId={component.subTaskFlowGUID}
                      ResponsiblePerson={
                        component.uS_User
                          ? component.uS_User?.firstName +
                            " " +
                            component.uS_User?.lastName
                          : "غير محدد"
                      }
                      subTaskName={component.taskFlow.flow.flowName}
                      subTaskStatus={component.wfTaskStatus.taskStatusName}
                      disabled={true}
                    />,
                  ]}
                />
              );
            })
          : ""}
        {decodeParam(flow) == "6310803f-9c2e-4b7d-b8b8-35451a4ebc99" ? (
          <p id="avg">
            المعدل الاجمالي :{" "}
            {state.MarksAvg ? parseFloat(state.MarksAvg?.toFixed(2)) : ""}%
          </p>
        ) : (
          ""
        )}
        {/* [,] */}
        {/* تكون غير قابلة للتعديل في حال كانت حالتها مغلقة */}
        <RecommendationMainTask
          flowGUID={decodeParam(flow)}
          taskId={decodeParam(taskId)}
          disabled={
            decodeParam(taskStatusGUID) ==
              "b8207a91-b6c1-4284-89c7-3acd8a492875" ||
            decodeParam(userGuid) != userInfoData?.UserGuid
              ? true
              : false
          }
        />
        {/* [,] */}
        {/* تكون غير قابلة للتعديل في حال كانت حالتها مغلقة ولم يكن نفس الشخص المسؤؤل عن هذه المهمة*/}

        {state.ActionButtons &&
        state.ActionButtons.length > 0 &&
        !(
          decodeParam(taskStatusGUID) ==
            "b8207a91-b6c1-4284-89c7-3acd8a492875" ||
          decodeParam(userGuid) != userInfoData?.UserGuid
        ) ? (
          <ButtonActionManager
            list={state.ActionButtons}
            subTaskGuid={decodeParam(taskId)}
            taskGuid={decodeParam(taskId)}
            typeTasks={true}
          />
        ) : (
          ""
        )}
      </div>
      <LoaderAHSF show={loading} />
    </>
  );
}
